import axios from 'axios';

class FormRepository{

    constructor(token) {
        this.token = token;
    }

    async fetch(id){
        
        const response = await axios.get(`${process.env.REACT_APP_API_HOST}forms/${id}`, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
            params: {
              expand: 'criteria,answers.answerAttachments,answers.question,schedule.instrument.score.scoreIndices,schedule.auditee.department',
            }
          });

        return response; 

    }

    async update(id, data){
        const response = await axios.put(
            `${process.env.REACT_APP_API_HOST}forms/${id}`, data,
            { headers: {
                Authorization: `Bearer ${this.token}`,
              },
            }
        );

        return response;
    }

}

export default FormRepository;